import { render, staticRenderFns } from "./DataInitialize.vue?vue&type=template&id=22d70920&"
import script from "./DataInitialize.vue?vue&type=script&lang=ts&"
export * from "./DataInitialize.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports